import HelperLoader from "../../helpers/loader.js";
import Config from "./config.js";

/**
 * Loader — HubSpot's forms embed, once per page, resolving `window.hbspt`.
 *
 * Shared promise: a profile mounts two forms and must not race two copies of the script. The
 * TIMEOUT is create()'s, not this file's — it covers the form rendering too, not just the script.
 */
const Loader = {};

let pending = null;

Loader.ready = () => typeof window.hbspt?.forms?.create === "function";

/** @return {Promise<object>} window.hbspt; rejects when the script fails or arrives without it */
Loader.load = function () {
  if (Loader.ready()) return Promise.resolve(window.hbspt);

  pending ??= HelperLoader.loadScripts([Config.scriptSrc()]).then(() => {
    if (!Loader.ready()) throw new Error("embed loaded without window.hbspt");

    return window.hbspt;
  });

  return pending;
};

export default Loader;
